module.exports = __webpack_public_path__ + "img/ZWT.6518ff31.png";